import { Component, type ErrorInfo, type ReactNode } from 'react'
import type { NotificationResource } from '../../../api/notifications'
import { FallbackNotificationCard } from '../NotificationCards/FallbackNotificationCard'

type Props = {
  notification: NotificationResource
  children: ReactNode
}

type State = {
  hasError: boolean
}

export class NotificationEventItemBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Notification card render failed', {
      notificationId: this.props.notification.id,
      type: this.props.notification.type,
      error,
      componentStack: info.componentStack,
    })
  }

  componentDidUpdate(prevProps: Props): void {
    if (prevProps.notification.id !== this.props.notification.id && this.state.hasError) {
      this.setState({ hasError: false })
    }
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return <FallbackNotificationCard notification={this.props.notification} />
    }

    return this.props.children
  }
}
